import { type IToggle, type IVariant} from "@unleash/nextjs";

import { FeatureFlag } from "@/services/unleash/featureFlags";

export default Object.values(FeatureFlag).map(value => ({
    name: value,
    enabled: false,
    variant: {} as IVariant,
    impressionData: false,
} as IToggle));
